import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito conocimientos de herboristería para usar este manual?',
    a: 'No. El manual está diseñado específicamente para personas sin experiencia previa. Cada protocolo explica el porqué, el cómo y el cuándo — con ingredientes que ya reconoces de tu cocina.'
  }, {
    q: '¿Esto reemplaza a mi médico?',
    a: 'No. Es material educativo y de apoyo natural. Si tienes condiciones o tomas medicamentos, consulta a tu profesional de salud antes de iniciar cualquier protocolo.'
  }, {
    q: '¿Los ingredientes son difíciles de conseguir?',
    a: 'No. Está diseñado con ingredientes comunes disponibles en supermercados, mercados y tiendas naturistas de toda América Latina. El Bono #2 incluye una lista de compras con sustituciones para que nunca te quedes parado.'
  }, {
    q: '¿Cómo recibo el manual?',
    a: 'Descarga digital inmediata tras el pago. Recibes un enlace en tu correo en menos de 2 minutos. Funciona en celular, tablet y computadora.'
  }, {
    q: '¿Necesito experiencia con plantas medicinales?',
    a: 'No. Cada protocolo incluye ingredientes, cantidades exactas, preparación paso a paso y notas de seguridad. Si puedes hervir agua, puedes aplicar estos protocolos.'
  }, {
    q: '¿Y si no es para mí?',
    a: 'Tienes 7 días de garantía total. Si no notas ninguna diferencia, aunque sea pequeña, te devolvemos el 100%. Sin preguntas. Sin trámites. Sin letra chica.'
  }, {
    q: '¿Funciona si ya tomo medicamentos?',
    a: 'El manual incluye una sección de seguridad con contraindicaciones documentadas. Para mayor tranquilidad, consulta con tu médico — el Bono #3 incluye una plantilla simple para abrir esa conversación sin confrontación.'
  }];
  return <section className="py-16 px-4 bg-[#FEFCF6]" data-id="element-255">
      <div className="max-w-[700px] mx-auto" data-id="element-256">
        <h2 className="text-3xl font-serif font-bold text-[#2C1810] text-center mb-8" data-id="element-257">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3 mb-12" data-id="element-258">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-[#E8DFD0] rounded-lg overflow-hidden" data-id="element-259">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-4 text-left font-semibold text-[#2C1810] hover:bg-[#F0F4EC] transition-colors" data-id="element-260">
                {faq.q}
                <ChevronDown className={`w-5 h-5 text-[#2D5A3D] transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-261" />
              </button>
              <AnimatePresence data-id="element-262">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-263">
                    <div className="px-4 pb-4 pt-0 text-[#5C4A3A] leading-relaxed border-t border-[#F0F4EC] mt-2" data-id="element-264">
                      <div className="pt-3" data-id="element-265">{faq.a}</div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}